import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFlow } from "../context/FlowContext";
import { useI18N } from "../context/I18NContext";
import { BoxContainer } from "../layouts/Theme";
import RegisterForm from "../partials/account/RegisterForm";
export default function AccountDetails(props) {
    const { t } = useI18N();
    const flow = useFlow();
    const location = useLocation();
    // The same form on two routes: 'accountDetails' is the step in the flow, 'accountDetails1'
    // the consumer's own screen. Taken from the route rather than from flow.currentRoute, which
    // only points at this view while it is a step - on accountDetails1 it is outside the flow.
    const mode = location.pathname.replace('/oa_widget_', '');
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Persoonlijke gegevens');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    return (_jsx(_Fragment, { children: _jsx(BoxContainer, { children: _jsx(RegisterForm, { mode: mode, registerRequired: false }) }) }));
}
